const img = require('./text_underline_s_default.png'); export default img;